<template>
  <Modal v-model="modalVersionNote" footer-hide width="1000">
    <p slot="header" class="text-center">
        <span>笔记</span>
    </p>
    <Row>
      <i-col span="24">
        <Input v-model="noteContent" :rows="4" maxlength="1000" show-word-limit  type="textarea" placeholder="输入版本笔记内容..." style="width: 100%" />
      </i-col>
    </Row>
    <p class="text-right p-t-10">
      <i-button size="small"  type="success" :disabled="noteContent.length<1" @click="handleSaveNote">保存笔记</i-button>
    </p>
    <div class="text-16">
      历史笔记
      <Divider style="margin: 5px 0;"/>
      <List v-if="historyNotes.length>0">
        <ListItem v-for="(note,index) in historyNotes" :key="index">
            <ListItemMeta :title="note.createTime+'（' + note.userName + '）' "
              :description="note.updateAfter"/>
        </ListItem>
      </List>
      <p v-else class="text-center remark p-t-10">暂无数据</p>
    </div>
  </Modal>
</template>

<script>
import { getServiceNoteList, addNote } from '@/api/msp/serviceversion'

export default {
  data () {
    return {
      modalVersionNote: false,
      serviceVersionId: 0,

      noteContent: '',
      historyNotes: []
    }
  },
  methods: {
    showModal (serviceVersionId) {
      this.modalVersionNote = true
      this.noteContent = ''
      this.serviceVersionId = serviceVersionId

      this.loadNotes()
    },
    loadNotes () {
      getServiceNoteList({ serviceVersionId: this.serviceVersionId }).then(res => {
        this.historyNotes = res
      })
    },
    handleSaveNote () {
      const saveBean = {
        note: this.noteContent,
        versionId: this.serviceVersionId
      }

      addNote(saveBean).then(res => {
        this.loadNotes()
        this.noteContent = ''
        this.$Notice.success({ desc: '版本笔记添加成功！' })
      })
    }
  }
}
</script>
